var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemittanceRateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.375 17.333H4.5V4.667C4.5 4.3 4.219 4 3.875 4h-1.25C2.281 4 2 4.3 2 4.667v14C2 19.404 2.559 20 3.25 20h18.125c.344 0 .625-.3.625-.667V18c0-.367-.281-.667-.625-.667Zm-1.25-12h-4.613c-.836 0-1.254 1.08-.664 1.709l1.265 1.35-2.863 3.058-2.867-3.058a1.197 1.197 0 0 0-1.77 0L5.93 11.254a.693.693 0 0 0 0 .942l.883.941c.246.263.64.263.882 0L9.5 11.221l2.867 3.058a1.198 1.198 0 0 0 1.77 0l3.75-4 1.265 1.35c.59.63 1.602.184 1.602-.708V6c0-.367-.281-.667-.625-.667h-.004Z",
    fill: "#062F6D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemittanceRateIcon);
export default __webpack_public_path__ + "static/media/remittance-rate-icon.2c52136e37741baef0a6772e8ca51d48.svg";
export { ForwardRef as ReactComponent };